/**
 * @generated SignedSource<<cfb9ba6cd84ef19146827c38e1d50344>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnlinkPipedriveDealInput = {
  projectId?: string | null;
  dealId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UnlinkPipedriveDealMutation$variables = {
  input: UnlinkPipedriveDealInput;
};
export type UnlinkPipedriveDealMutation$data = {
  readonly unlinkPipedriveDeal: {
    readonly project: {
      readonly pipedriveDeal: string | null;
    } | null;
  } | null;
};
export type UnlinkPipedriveDealMutation = {
  variables: UnlinkPipedriveDealMutation$variables;
  response: UnlinkPipedriveDealMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveDeal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "unlinkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkPipedriveDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkPipedriveDealPayload",
        "kind": "LinkedField",
        "name": "unlinkPipedriveDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f15de0c5a085ef9c869e2ac406110938",
    "id": null,
    "metadata": {},
    "name": "UnlinkPipedriveDealMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkPipedriveDealMutation(\n  $input: UnlinkPipedriveDealInput!\n) {\n  unlinkPipedriveDeal(input: $input) {\n    project {\n      pipedriveDeal\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc2aab52b158b15e0954b566a1554777";

export default node;
